import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { BehaviorSubject, Observable } from 'rxjs';
import { IDocument } from 'src/app/core/interfaces/common/document/document.interface';
import { DocumentService } from 'src/app/core/services/common/document.service';


@Component({
  selector: 'app-document-upload-summary',
  templateUrl: './document-upload-summary.component.html',
  styleUrls: ['./document-upload-summary.component.scss']
})
export class DocumentUploadSummaryComponent {
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
  @Input() documentBehaviorSubject: BehaviorSubject<IDocument[]>;
  @Input() onDownload: (docId: number) => Promise<IDocument>;
  @Output() outputParameter: EventEmitter<any> = new EventEmitter<any>();
  public gridData: Observable<IDocument[]>;
  isLoading: boolean;
  @Input() pageSize = 5;
  @Input() showWhenEmpty = false;

  constructor(private ds: DocumentService) { }
  ngOnInit(): void {
    this.isLoading = true;
    this.gridData = this.documentBehaviorSubject.asObservable();
    this.isLoading = false;
  }


  async downloadRecord(id: number) {
    this.isLoading = true;
    const file = await this.onDownload(id);
    this.isLoading = false;
    this.downloadFile(file.fileContent, file.fileName, file.contentType);
  }

  // To download the pdf
  downloadFile(base64String: string, fileName: string, contentType: string) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i += 1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });

    const downloadLink = document.createElement('a');
    const url = URL.createObjectURL(blob);

    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.click();

    URL.revokeObjectURL(url);
  }
}
